export const amountNumberFormat = (number) => {
  const value = Number(number ?? 0);
  return isNaN(value) ? "0" : new Intl.NumberFormat().format(value);
};
